import React, { useState } from 'react';
import { X, BookOpen, Check, X as XIcon } from 'lucide-react';
import { ColorPicker } from 'antd';

const AddCourseModal = ({ isOpen, onClose, onConfirm }) => {
  const [courseName, setCourseName] = useState('');
  const [courseColor, setCourseColor] = useState('#3B82F6');

  if (!isOpen) return null;

  const handleConfirm = () => {
    if (courseName.trim()) {
      onConfirm({
        name: courseName.trim(),
        color: courseColor
      });
      setCourseName('');
      setCourseColor('#3B82F6');
      onClose();
    }
  };

  const handleCancel = () => {
    setCourseName('');
    setCourseColor('#3B82F6');
    onClose();
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleConfirm();
    } else if (e.key === 'Escape') {
      handleCancel();
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content max-w-md relative" onClick={(e) => e.stopPropagation()}>
        {/* 关闭按钮 */}
        <button 
          onClick={onClose} 
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors duration-200 p-2 rounded-full hover:bg-gray-100 z-10 flex items-center justify-center"
        >
          <X size={18} />
        </button>

        <div className="modal-header">
          <h3 className="text-lg font-semibold text-gray-900 flex items-center">
            <BookOpen size={20} className="mr-2" />
            添加课程
          </h3>
        </div>

        <div className="modal-body">
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              课程名称
            </label>
            <input
              type="text"
              value={courseName}
              onChange={(e) => setCourseName(e.target.value)}
              onKeyDown={handleKeyPress}
              placeholder="请输入课程名称"
              className="w-full p-3 border-2 border-gray-300 rounded-lg text-sm transition-colors duration-300 focus:border-primary-500 focus:outline-none focus:ring-2 focus:ring-primary-200"
            />
          </div>
          
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              课程颜色
            </label>
            <div className="flex items-center gap-3">
              <ColorPicker
                value={courseColor}
                onChange={(color) => setCourseColor(color.toHexString())}
                showText
                size="large"
                style={{ width: '120px' }}
              />
            </div>
          </div>
        </div>
        
        <div className="modal-footer">
          <button className="btn btn-primary" onClick={handleConfirm}>
            <Check size={16} className="mr-2" />
            确认
          </button>
          <button className="btn btn-danger" onClick={handleCancel}>
            <XIcon size={16} className="mr-2" />
            取消
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddCourseModal;
